import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var PayoutNotReceivedIA = function PayoutNotReceivedIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Vlx7bU",
    defaultMessage: [{
      "type": 0,
      "value": "Se ocorrer um atraso na receção do pagamento, deve verificar algumas informações importantes sobre as definições das encomendas e da conta para compreender o motivo. Saiba o que deve verificar:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "L8yZ/q",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Estado da encomenda:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " para a emissão do pagamento ser acionada, a sua encomenda tem de ser assinalada como \"Enviada\". Verifique se introduziu as informações de acompanhamento de envio para o estado ser atualizado corretamente."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "bNsRBC",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Opções de pagamento:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " reveja as "
    }, {
      "children": [{
        "type": 0,
        "value": "condições de pagamento"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": " que selecionou. O pagamento é iniciado até 60 dias após o envio, consoante o prazo que escolher. Habitualmente, o pagamento demora 3 a 5 dias úteis a aparecer na sua conta, consoante o tempo de processamento do seu banco."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      },
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "KumpfT",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Informações da conta bancária:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " verifique novamente se os dados da sua conta bancária estão corretos e atualizados. Informações incorretas podem causar atrasos nos pagamentos."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hLc85/",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Pré-encomendas:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " no caso das pré-encomendas, as datas de pagamento e de envio podem estar indicadas como \"Desconhecidas\" até concluir o processamento da pré-encomenda. Estas encomendas têm de ser processadas antes de os pagamentos poderem ser emitidos."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};